// extracted by mini-css-extract-plugin
module.exports = {"blogs_div_main":"Blogs_blogs_div_main__350NR","blogs_div":"Blogs_blogs_div__2369L","github_div":"Blogs_github_div__1OgnB","hideme":"Blogs_hideme__1iadN"};